import { Box } from "@mui/material";
import "./App.css";
import Navbar from "./components/NavBar";
import Home from "./pages/Home";
import Calendario from "./pages/Calendario";
import Contactos from "./pages/Contactos";
import Cursos from "./pages/Cursos";
import Toefl from "./pages/Toefl";
import Traducciones from "./pages/Traducciones";
import Videos from "./pages/Videos";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import { HashRouter } from "react-router-dom";

function App() {
  return (
    <Box>
      <HashRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/toefl" element={<Toefl />} />
          <Route path="/calendario" element={<Calendario />} />
          <Route path="/traducciones" element={<Traducciones />} />
          <Route path="/contactos" element={<Contactos />} />
          <Route path="/videos" element={<Videos />} />
        </Routes>
        <Footer />
      </HashRouter>
    </Box>
  );
}

export default App;
